import React from 'react';
import { Form, Input, Row, Col, Modal, Select } from 'antd';
import { useTranslation } from "react-i18next";

const TriggerAlertModal = (props) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const { TextArea } = Input;

  const onFinish = (values) => {
    console.log('Received values:', values);
    props.action(values);
    props.close();
  };

  return (
    <Modal
      title={t("alert.TriggerAlert")}
      open={props.visible}
      onOk={() => form.submit()}
      onCancel={props.close}
    >
      <Form
        form={form}
        onFinish={onFinish}
        layout="vertical"
      >
        <Row gutter={16}>
          <Col span={24} lg={12}>
          <Form.Item
              label={t("alert.table.urgency")}
              name="urgency"
              rules={[{ required: true, message: t("PleaseSelectUrgency") }]}
            >
              <Select>
                <Select.Option value={0}>{t("alert.urgency_levels.information")}</Select.Option>
                <Select.Option value={1}>{t("alert.urgency_levels.attention")}</Select.Option>
                <Select.Option value={2}>{t("alert.urgency_levels.escalated")}</Select.Option>
                <Select.Option value={3}>{t("alert.urgency_levels.urgent")}</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label={t("alert.table.details")}
              name="details"
              rules={[{ required: true, message: t("alert.PleaseEnterDetails") }]}
            >
              <TextArea />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default TriggerAlertModal;
